import React, { Component, useState, useEffect } from 'react'
import axios from 'axios'
import { normalizeString, hasParent } from '../helpers/Common'
import image from '../../assets/images/hero-element.png'
import futuro from '../../assets/images/futuro.png'
import possibilidades from '../../assets/images/possibilidades.png'
import card_01 from '../../assets/images/card-1.png'
import card_02 from '../../assets/images/card-2.png'
import card_03 from '../../assets/images/card-3.png'
import card_04 from '../../assets/images/card-4.png'
import card_05 from '../../assets/images/card-5.png'
import card_06 from '../../assets/images/card-6.png'
import carrinho from '../../assets/images/carrinho.png'

class AdesaoDigital extends Component {

    state = {
        isLoaded: false,
        plains: false,
        matches: [],
        opened: false,
        keyword: false,
        selected: false,
    }
    
    constructor( props ){

        super( props );

        this.bindChange = this.bindChange.bind(this)
        this.bindSelect = this.bindSelect.bind(this)
        this.goToForm = this.goToForm.bind(this)
        this.bindSubmit = this.bindSubmit.bind(this)

    }

    componentDidMount () {

        const SERVER_URL = process.env.REACT_APP_SERVER_URL;

        axios
            .get( SERVER_URL + 'wp-json/bbprev/v1/planos-adesao' )
            .then(( res ) => {
                this.setState({
                    plains: res.data,
                    matches: res.data,
                    isLoaded: true
                })
            })
            .catch(
                err => console.log(err)
            )
        ;

    }
    
    bindChange( keyword ){

        let newState = { keyword: keyword }
        this.setState( newState, () => {

            if( this.timeChange ) clearTimeout(this.timeChange)
                this.timeChange = setTimeout( () => {
                this.bindSubmit()
            }, 200)
   
        })

    }
    
    bindSubmit = () => {

        const { plains } = this.state;
        const keyword = this.state.keyword.toLowerCase();

        let matches = [];
        if( keyword.length <= 2 ){
            
            matches = plains
        
        }
        else {

            plains.forEach(function( plano ){

                const planName = normalizeString(plano.post_title.toLowerCase())
                const keywordCompare = normalizeString(keyword)

                if( planName.includes( keywordCompare ) ){
                    matches.push( plano );
                }
                else if( plano.searchkeys ) {
                    plano.searchkeys.forEach(function( searchkey ){
                        if( searchkey.toLowerCase() === keyword ){
                            matches.push( plano );
                        }
                    });
                }
                
            })

        }

        this.setState({ 
            matches: matches,
            selected: false,
            errorText: !matches.length ? this.state.keyword : ''
        });

    }

    bindSelect( plain ){
        this.setState({
            keyword: plain.post_title,
            selected: plain
        })
    }

    goToForm(){

        const formAdesao = document.querySelector('#form-adesao')
        window.scrollTo({
            top: formAdesao.offsetTop,
            behavior: 'smooth'
        })

    }
    
    render() {

        const { plains, selected, isLoaded } = this.state
        if( !isLoaded ) return null;

        let 
            adesaoStatus = false,
            adesaoType = null,
            adesaoURL = null
        ;
        if( selected ){

            if( selected.adesao.code !== '' ){
                adesaoStatus = true;
                adesaoType = 'code';
                adesaoURL = 'https://www.bbprevidencia.com.br/cadastroweb/dispatcher/acessoIdentificado/' + selected.adesao.code;
            }
            else if( selected.adesao.url !== '' ){
                adesaoStatus = true;
                adesaoType = 'external';
                adesaoURL = selected.adesao.url;
            }
       
        }

        return (
        <main id="adesao-digital" className="adesao-digital">
            <header>
                <div className="inner">
                    <div className="content">
                        <div className='image'>
                            <picture>
                                <img src={image} alt="Aderiu, Ganhou! Faça sua adesão ao plano de Prebvidência Complementar e Ganhe 5 mil pontos Livelo para usar como quiser" />
                            </picture>
                        </div>
                        <em>Campanha válida de 16/06 a 31/08. Consulte o regulamento.</em>
                    </div>
                    <div className="firulas">
                        <div>
                            <span><span></span></span>
                            <span><span></span></span>
                            <span><span></span></span>
                            <span><span></span></span>
                            <span><span></span></span>
                        </div>
                    </div>
                    <div className="button-wrapper">
                        <button type="button" onClick={this.goToForm}>Faça a sua adesão agora!</button>
                    </div>
                </div>
            </header>
           <section className="futuro">
                <div>
                    <div className="div-left">
                        <h2>Já pensou em receber presentes agora, só por começar a investir no seu futuro?</h2>
                        <strong>É isso que a BB Previdência está oferecendo pra você!</strong>
                    </div>
                    <div className="div-right">
                        <em>Agora, ao aderir ao plano de previdência complementar, você está ganhando em dobro:</em>
                        <div>
                            <picture>
                                <img src={futuro} alt="" />
                            </picture>
                        </div>
                    </div>
                </div>
            </section>
            <section className='possibilidades'>
                <div className='plano'>
                    <div className='possi-left'>
                        <h2>Você adere ao plano. A gente entrega 5 mil possibilidades</h2>
                        <em>Nunca ouviu falar da Livelo? É simples: <strong>é como ganhar créditos para transformar em coisas que você ama. Viajar, comprar, viver experiências — seus pontos fazem isso por você.</strong></em>
                    </div>
                    <div className='possi-right'>
                        <picture>
                            <img src={possibilidades} alt="" />
                        </picture>
                    </div>
                </div>
                <button type="button" className='button-adesao' onClick={this.goToForm}>Faça a sua adesão agora!</button>
                <div className='pode-fazer'>
                    <h2>E oque você pode fazer com <strong>5 mil pontos?</strong></h2>
                    <ul>
                        <li>
                            <picture>
                                <img src={card_01} alt="" />
                            </picture>
                        </li>
                        <li>
                            <picture>
                                <img src={card_02} alt="" />
                            </picture>
                        </li>
                        <li>
                            <picture>
                                <img src={card_03} alt="" />
                            </picture>
                        </li>
                        <li>
                            <picture>
                                <img src={card_04} alt="" />
                            </picture>
                        </li>
                        <li>
                            <picture>
                                <img src={card_05} alt="" />
                            </picture>
                        </li>
                        <li>
                            <picture>
                                <img src={card_06} alt="" />
                            </picture>
                        </li>
                    </ul>
                    <div>
                        <picture>
                            <img src={carrinho} alt="" />
                        </picture>
                    </div>
                </div>
            </section>
            {( plains && plains.length ) &&
            <section className='decisao'>

                <div>
                    <em>Com uma única decisão, você garante uma aposentadoria mais segura e ainda se presenteia com 5 mil pontos
                        Livelo. É o tipo de escolha inteligente que traz retorno agora — e depois também.</em>
                    <h2 className='title'>Faça a sua adesão</h2>
                </div>
                <div className='form'>
                    <div className='finder'>
                        <PlainsForm {...this.state} onChange={this.bindChange} onSelect={this.bindSelect} />
                    </div>
                </div>

                {( adesaoStatus ) &&
                <div className="adesao-result">
                    {( adesaoType === 'code' ) &&
                    <form action={adesaoURL} method="get" target="_blank">
                        <button type="submit">Fazer adesão agora!</button>
                    </form> }
                    {( adesaoType === 'external' ) &&
                    <a href={adesaoURL} target="_blank" rel="noreferrer">Fazer adesão agora!</a>}
                </div>}
                
                <div className="regulamento">
                    <em>Consulte <a href="https://bbprevidencia.com.br/blog/wp-content/uploads/2025/06/Regulamento-da-Campanha-BB-Previdencia-–-Aderiu-ganhou-Patrocinados.pdf" alt="" target="_blank" rel="noreferrer noopener">aqui</a> o regulamento</em>
                </div>

            </section>}

        </main>)
  
    }

} 
export default AdesaoDigital;

export function PlainsForm( props ){

    const [ opened, setOpened ] = useState(false)
    const keyword = ( !props.keyword ? '' : props.keyword )

    const bindChange = ( event ) => {
        setOpened( true )
        props.onChange( event.target.value )
    }

    const bindSelect = ( item ) => {
        props.onSelect( item )
        setOpened( false )
    }

    const checkOutClick = ( event ) => {
        if( hasParent(event.target, 'finder' ) !== true ){
            setOpened( false )
        }
    }
    const checkEscClick = ( event ) => {
        if( event.key === 'Escape' ){
            setOpened( false )
        }
    }

    useEffect( () => {

        document.addEventListener( 'click', checkOutClick )
        document.addEventListener( 'keyup', checkEscClick )

        return () => {
            document.removeEventListener( 'click', checkOutClick )
            document.removeEventListener( 'keyup', checkEscClick )
        };

    }, [] )

    if( !props?.plains || !props.plains.length ){
        return null
    }

    return(
    <form id="form-adesao" onSubmit={(e)=>{e.preventDefault()}}>
        <div>
            <label htmlFor="fname"></label>
            <input type="text" id="fname" name="fname" onChange={bindChange} onFocus={() => {setOpened(true)}} value={keyword} placeholder="Digite o nome da empresa em que trabalha" />
            <div className="search-icon"></div>
            {opened &&
            <div className='select'>
                <ul>
                    {props.matches.map( plain => {
                        return(
                        <li key={plain.ID}>
                            <button type="button" onClick={() => bindSelect(plain)}>{plain.post_title}</button>
                        </li>)
                    })}
                    {!props.matches.length && 
                    <li key="not-found">
                        <span>Nenhum plano encontrado</span>
                    </li>}
                </ul>
            </div>}
        </div>
    </form>)

}